
export var store = {
  debug: false,
  initialMarkerData: null,
  initialStoriesData: null,
  initialPresetsData: null,
  state: {
    filters: [
      { name: 'alkmaar', values : [] },
      { name: 'kopvannoord_holland', values : [] },
      { name: 'west_friesland', values : [] },
      { name: 'sector', values : [] },
      { name: 'typeactiviteit', values : [] },
      { name: 'onsnetwerk', values : [] },
      { name: 'gemeente', values : [] },
      { name: 'post_id', values : [] },
    ],
    detailPanel: {
      visible: false,
    },
  },

  updateFilterValues(filterName, values) {
    // try to find filterName
    const f = this.state.filters.find(x => x.name === filterName)
    // if filter found
    if (f !== undefined) {
      // init values
      f.values = []
      // add values to array
      values.forEach((v) => {
        f.values.push(v)
      })
    }
    // compute the filter 'gemeente' from filters
    let g = this.state.filters.find(x => x.name === 'gemeente')
    g.values = []
    if(this.state.filters[0].values != '') g.values += this.state.filters[0].values + ','
    if(this.state.filters[1].values != '') g.values += this.state.filters[1].values + ','
    if(this.state.filters[2].values != '') g.values += this.state.filters[2].values + ','
    
    if (this.debug) console.log('filters is now', this.state.filters)
  },

  getFilterValues(filterName) {
    const f = this.state.filters.find(x => x.name === filterName)
    if (f !== undefined) {
      return f.values
    }
  },

  resetFilterValues() {
    this.state.filters.forEach((f) => {
      f.values = []
    })
  },
  searchByString(str) {
    
    let ids=['-no-results-'] // make sure the map shows no results if no marker is found
    str = str.toLowerCase()

    this.initialMarkerData.forEach((f) => {
      
      // search for string in title
      if( f.post_title.toLowerCase().includes(str) ) {
        ids.push(f.post_id)
      }

    })
    this.updateFilterValues('post_id', ids)
  },
  getDetailPanelValue(key) {
    if(this.state.detailPanel.hasOwnProperty(key)) {
      return this.state.detailPanel[key]
    }
    return 'key not found'
  },

  setDetailPanelValue(key,val) {
    this.state.detailPanel[key] = val
    if (this.debug) console.log('detailPanel is now', this.state.detailPanel)
  },
}


// WEBPACK FOOTER //
// ./scripts/vue/store.js